import { createApp } from "vue";
import AlertModal from "../components/AlertModal.vue";
import { createConfiguredVuetify } from "./vuetify.js";
import i18n from "./i18n.js";

let alertComponentInstance = null;

function createAlertComponent(options)
{
  if (!alertComponentInstance)
  {
    const div = document.createElement("div");
    document.body.appendChild(div);

    const app = createApp(AlertModal, {
      title: options.props.title,
      text: options.props.html,
      variant: options.props.icon,
      isOpen: true,
    });

    app
      .use(createConfiguredVuetify())
      .use(i18n);

    alertComponentInstance = app.mount(div);
  }
  else
  {
    alertComponentInstance.modal.title = options.props.title;
    alertComponentInstance.modal.text = options.props.html;
    alertComponentInstance.modal.variant = options.props.icon;
    alertComponentInstance.modal.isOpen = true;
  }

  return alertComponentInstance;
}

export const showAlert = (options) => createAlertComponent({ props: options });

export const AlertPlugin = {
  install: (app) =>
  {
    app.config.globalProperties.$showAlert = (options) =>
    {
      createAlertComponent({ props: options });
    };
  },
};